import Skeleton from 'react-loading-skeleton'
import { buildIntrinsicWidthSources } from '@velasca/utils/build-intrinsic-width-sources'
import { setQueryParams } from '@velasca/utils/set-query-params'
import {
  BannerContent,
  BannerWrapper,
  Description,
  Img,
  ImgContainer,
  Link,
  Title,
} from './CollectionBanner.styles'
import type { CollectionBannerProps } from './CollectionBanner.types'

export const CollectionBanner = ({
  title,
  description,
  img,
  color,
  loading = false,
  collectionUrl,
}: CollectionBannerProps): JSX.Element => {
  return (
    <BannerWrapper>
      <Link href={collectionUrl}>
        <BannerContent $loading={loading} color={color}>
          <Title color={color}>
            {loading ? (
              <Skeleton
                count={2}
                width="75%"
                height="3.25rem"
                style={{ lineHeight: '25px' }}
              />
            ) : (
              title
            )}
          </Title>
          <Description>
            {loading ? (
              <Skeleton count={4} style={{ lineHeight: '22px' }} />
            ) : (
              description
            )}
          </Description>
          {loading ? (
            <ImgContainer>
              <Skeleton height="100%" width="100%" style={{ aspectRatio: 1 }} />
            </ImgContainer>
          ) : (
            img?.src && (
              <Img
                lazyload
                lqip
                title={title}
                alt={img.alt}
                sources={buildIntrinsicWidthSources({
                  src: img.src,
                  maxWidth: img.width,
                })}
                imgSrc={setQueryParams(img.src, [
                  { name: 'width', value: '30' },
                ])}
                /**
                 * Mostriamo l'immagine solo se esiste.
                 */
                onLoad={(e) => {
                  // eslint-disable-next-line no-param-reassign
                  e.currentTarget.style.display = 'block'
                }}
              />
            )
          )}
        </BannerContent>
      </Link>
    </BannerWrapper>
  )
}
